import {isExternal, isEmpty} from '../util/helpers'
import * as Cookies from 'js-cookie'

export default {
  init() {
    // JavaScript to be fired on all pages
    const anchors = document.querySelectorAll('a')
    const paragraphs = document.querySelectorAll('p')
    const hamburger = document.querySelector('.nav-control')
    const galleryThumbs = document.querySelectorAll('.gallery-icon')
    const jsPopup = document.querySelector('.js-popup')


    // Handle external urls
    anchors.forEach(anchor => {
      if (isExternal(anchor)) {
        // Define attributes to set
        const attributes = {
          target: '__blank',
          rel: 'noopener',
        }

        // Set attributes
        Object.keys(attributes).forEach(attribute => {
          anchor.setAttribute(attribute, attributes[attribute])
        })
      }
    })

    // Handle empty p tags
    paragraphs.forEach(isEmpty)

    $('.toggle__main--nav').click(function () {
      $(this).toggleClass('activated');
      $('.primary-nav-a').toggleClass('hidden');
    });

    // Handle hamburger toggle
    if (hamburger) {
      hamburger.addEventListener('click', () => {
        document.body.classList.toggle('nav-is-open')
      })
    }

    // Handle dropdowns visibility state
    $(function () {
      var children = $('nav > ul > .menu-item-has-children > a').filter(function () {
        return $(this).nextAll().length > 0;
      });
      $('<span class="drop-menu"><i class="fas fa-angle-down"></i></span>').insertAfter(children);
      $('nav ul .drop-menu').click(function () {
        $(this).toggleClass('activated');
        $(this).next().toggleClass('reveal-menu');
        return false;
      });
    });


    // Handle gallery lightbox
    if (galleryThumbs) {
      galleryThumbs.forEach(galleryThumb => {
        const galleryAnchor = galleryThumb.children[0]

        galleryAnchor.setAttribute('data-fancybox', 'gallery')
      })

      $('[data-fancybox]').fancybox()
    }

    // Handle Scroll Class for Header
    $(window).scroll(function () {
      var scrolled = $(this).scrollTop();

      if (scrolled >= 100) {
        $('body').addClass('scrolled');
      } else {
        $('body').removeClass('scrolled');
      }
    });

    if (jsPopup && !Cookies.get('popup')) {
      setTimeout(() => {
        $.fancybox.open({
          autoFocus: false,
          src: '.js-popup',
          type: 'inline',
        })

        Cookies.set('popup', 'true', {expires: 7})
      }, 5000)
    }

    // Slick Homes for sale gallery
    if ($('.js-carousel-gallery').length) {
      $('.js-carousel-gallery').slick({
        arrows: true,
        dots: false,
        fade: false,
        rows: 0,
        autoplay: true,
        autoplaySpeed: 15000,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: '<div class="next mr-15"><i class="fas fa-chevron-right text-red"></i></div>',
        prevArrow: '<div class="prev ml-15"><i class="fas fa-chevron-left text-red"></i></div>',
      });
    }

    if ($('.js-carousel-nav').length) {
      $('.js-carousel-nav').slick({
        arrows: false,
        asNavFor: '.js-carousel-gallery',
        dots: false,
        focusOnSelect: true,
        rows: 0,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: '60px',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              centerPadding: '60px',
            },
          },
        ],
      });
    }

    /// Column
    if ($('.col-slider').length) {
      $('.col-slider').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 15000,
        fade: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<div class="next"><i class="fal fa-chevron-right"></i></div>',
        prevArrow: '<div class="prev"><i class="fal fa-chevron-left"></i></div>',

        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              centerPadding: '15px',
            },
          },
        ],
      });
    }

    if ($('.col-slider-two').length) {
      $('.col-slider-two').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 15000,
        fade: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<div class="next"><i class="fal fa-chevron-right"></i></div>',
        prevArrow: '<div class="prev"><i class="fal fa-chevron-left"></i></div>',

        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              centerPadding: '15px',
            },
          },
        ],
      });
    }

    if ($('.col-slider-three').length) {
      $('.col-slider-three').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 15000,
        fade: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<div class="next"><i class="fal fa-chevron-right"></i></div>',
        prevArrow: '<div class="prev"><i class="fal fa-chevron-left"></i></div>',

        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              centerPadding: '15px',
            },
          },
        ],
      });
    }
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

(function ($) {
  function collectDataTemplates() {
    let dataAttr = {
      action: 'load_templates',
      post_id: $('.single-tab.active').data('tab'),
    }
    return dataAttr;
  }


  function loadTemplates(attr) {

    $.ajax({
      url: window.sage.ajax_url,
      type: 'POST',
      data: attr,
      beforeSend: function beforeSend() {
        $('#templates-flexible').html('<div class="ajax-preloader-wrapper"><div class="ajax-preloader"></div></div>');
        $('#acc-' + attr.post_id).html('<div class="ajax-preloader-wrapper"><div class="ajax-preloader"></div></div>');
      },

      success: function (response) {
        if ($(window).width() < 1024) {
          $('.ajax-mob').hide();
          $('#acc-' + response.data.acc).html(response.data.posts).show();

        } else {
          $('#templates-flexible').html(response.data.posts);
        }
      },
    });
  }


  if ($('.section-product-tabs').length > 0) {
    loadTemplates(collectDataTemplates());
    $('.single-tab').on('click', function (e) {
      e.preventDefault();
      $('.single-tab').removeClass('active');
      $(this).addClass('active');
      loadTemplates(collectDataTemplates());
      if ($(window).width() < 1024) {
        $('.ajax-desc').hide();
      } else {
        $('.ajax-mob').hide();
      }
    });

  }

// Get page title "Product single" set it as the value fot the input field on "Pricing" page
// Function to update the input field value
  function updateInputValue(inputSelector) {
    let pageTitle = $('.breadcrumbs .current-item').text();
    window.location.href = `/${inputSelector}?title=${encodeURIComponent(pageTitle)}`;
  }

// Event delegation to handle click events on buttons
  $(document).on('click', '.button.button--primary.md\\:mr-4', function(e) {
    e.preventDefault();
    updateInputValue('pricing');
  });

  $(document).on('click', '.button.button--secondary.md\\:mr-5', function(e) {
    e.preventDefault();
    updateInputValue('sample');
  });

// Retrieve title from URL parameters and update input fields
  let urlParams = new URLSearchParams(window.location.search);
  let title = urlParams.get('title');
  if (title) {
    $('#input_2_7').val(decodeURIComponent(title));
    $('#input_5_7').val(decodeURIComponent(title));
  }


// Menu Overlay
    $('.header__bottom .header_nav_a > .menu-item, .sub-menu-wrap').on('mouseenter', function() {
      $('body').addClass('overlay');
    });

    $('.header_nav_a > .menu-item').on('mouseleave', function() {
    $('body').removeClass('overlay');
  });

}(jQuery));




// WEBPACK FOOTER //
// ./scripts/routes/common.js